window.MD_FIREBASE_CONFIG = {
  apiKey: "AIzaSyAcprvXQ3R4rvSZ1WAEf646pGKkqyrUNX0",
  authDomain: "midesmadre.firebaseapp.com",
  projectId: "midesmadre",
  storageBucket: "midesmadre.firebasestorage.app",
  messagingSenderId: "738750835797",
  appId: "1:738750835797:web:6a65c6cd83b8d8461878dc"
};